import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/theme.css';
import Routes from './util/Routes'
import { ToastContainer } from 'react-toastify'

const Close = ({ closeToast }) => <b onClick={closeToast}>x</b>

ReactDOM.render(
    <>
        <ToastContainer className="toast-container" closeButton={<Close />} closeOnClick draggable={false} position="bottom-right" />
        <Routes />
    </>,
    document.getElementById('root')
)